const sideNav = {
  defaultHeading: "On this page",
};

export default sideNav;
